import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_inspection_projects } from '../../actions/v3/inspection';
import Layout from '../../components/common/pageLayout'
import './inspection.css'
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import constant from '../../constant';
import Filter from '../../components/Inspection/List/filter';
import List from '../../components/Inspection/List/index';
import { replacePageState } from '../../utils';

const Index = (props) => {


  const location = useLocation();
  const { page } = location.state || {};
  const [data, setData] = useState(null)
  const [currentPage, setCurrentPage] = useState(page ? page : 1)
  const [limit, setLimit] = useState(10)
  const [keyword, setKeyword] = useState('');
  const [groupBy, setGroupBy] = useState('none');

  // Filter changes always send us back to the first page, so reset alongside
  // the filter itself — a separate reset effect would fire a second request.
  const handleKeyword = (value) => {
    setKeyword(value);
    setCurrentPage(1);
  }

  const handleGroupBy = (value) => {
    setGroupBy(value);
    setCurrentPage(1);
  }

  useEffect(() => {
    let stale = false;
    v3_inspection_projects(currentPage, limit, keyword, groupBy).then((res) => {
      if (stale) return;
      if (res.status) {
        setData(res.result);
        replacePageState(props.history, constant.Authedcomponent.inspectionIndex.url, {
          page: currentPage
        });
      }
      else {
        toast.error(res.error)
      }
    })
    return () => { stale = true }
  }, [currentPage, limit, keyword, groupBy])
  return (
    <Layout title='Inspection'>
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id={1}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="appraisal-report-table-responsive">
                    <Filter
                      keyword={keyword}
                      setKeyword={handleKeyword}
                      groupBy={groupBy}
                      setGroupBy={handleGroupBy}

                    />

                    {data && <List
                      data={data}
                      limit={limit}
                      handlePageChange={(newPage) => setCurrentPage(newPage)}
                    />}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </Layout>
  )
}

export default Index